
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-tabs",
      function () {
        return require("private-next-pages/material-ui/react-tabs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-tabs"])
      });
    }
  